export const update_user_password = `mutation update_user_password($input: UpdateUserPassword!){
    update_user_password(input: $input)
}`;
